import {
    Container,
    NineSlicePlane,
    Texture,
    Sprite
} from 'pixi.js';
import { Focusable } from './FocusManager';
import { LoadContext } from '../utils';
import { StyledBitmapText } from './StyledBitmapText';
import { BitmapTextStyleOpts } from './BitmapTextStyle';

// Focusable UI Label
export class UILabel extends Container implements Focusable
{
    private focusBox:NineSlicePlane;
    private text:StyledBitmapText;
    public icon:Sprite;

    public static preload()
    {
        LoadContext.current.add('SharedUI', './assets/shared/SharedUI{size}.json');
    }

    constructor( content:string, style:BitmapTextStyleOpts, icon?: Texture )
    {
        super();

        this.text = new StyledBitmapText(content, style);
        this.text.anchor.set(0.5, 0.6);
        this.addChild( this.text );

        if (icon)
        {
            this.icon = new Sprite(icon);
            this.icon.anchor.y = 0.5;
            this.icon.x = this.text.width / 2 + 10;
            this.addChild(this.icon);

            this.icon.interactive = true;
            this.icon.cursor = 'pointer';
        }

        this.enabled = true;

        // after we are set up, make the focus -
        // allows subclasses to have their own size info or just override sprite
        setTimeout(this.createFocus.bind(this), 0);
    }

    private createFocus()
    {
        const FRAME_WIDTH = 6;
        this.focusBox = new NineSlicePlane(LoadContext.current.getSpritesheet('SharedUI').textures['highlight_frame'], FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH);
        const {width, height} = this.getSize();
        // make box just a tad bigger than whatever the size is
        this.focusBox.width = width + 20;
        this.focusBox.height = height + 20;
        this.focusBox.position.set(-this.focusBox.width / 2, -this.focusBox.height / 2);
        this.addChild(this.focusBox);
        this.focusBox.visible = false;
    }

    private getSize()
    {
        const target = this.text;
        return {width: target.width, height: target.height};
    }

    public get focus() { return this.focusBox.visible; }
    public set focus(focused) {
        this.focusBox.visible = focused;
        if (focused)
        {
            this.emit('pointerover');
            this.emit('focused');
        }
        else
        {
            this.emit('pointerout');
            this.emit('unfocused');
        }
    }

    public get focusVisible() { return this.focusBox.visible; }
    public set focusVisible(visible) {
        this.focusBox.visible = visible;
    }

    public activate()
    {
        if (!this.enabled) return;

        this.emit('pointertap');
    }

    public get enabled() { return this.interactive; }
    public set enabled(enabled)
    {
        this.interactive = enabled;
        // this.cursor = enabled ? 'pointer' : null;
    }

    public destroy()
    {
        super.destroy({children: true});
    }
}
